export default "__VITE_ASSET__MLP0GuaC__"